var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal-action-" + _vm.action,
      attrs: {
        id: "modal-action-" + _vm.action,
        title: _vm.title + " documento",
        "data-cy": "modal-action-document",
        "ok-title": _vm.title,
        "cancel-title": "Cancelar",
        "ok-disabled": _vm.loading,
        size: "lg"
      },
      on: {
        ok: _vm.commitAction,
        cancel: _vm.cancelProcess,
        close: _vm.cancelProcess
      }
    },
    [
      _c("b-overlay", { attrs: { show: _vm.loading } }, [
        _c("div", { staticClass: "mt-2" }, [
          _vm.action !== "attach"
            ? _c(
                "form",
                { attrs: { "data-vv-scope": "comment-management" } },
                [
                  _c("vs-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required:
                            _vm.action === "reject" || _vm.action === "comment",
                          min: _vm.action === "reject" ? 5 : 1
                        },
                        expression:
                          "{required: (action === 'reject' || action === 'comment'), min: action === 'reject' ? 5 : 1}"
                      }
                    ],
                    staticClass: "mb-2",
                    attrs: {
                      maxlength: "1000",
                      counter: "1000",
                      label: "Comentario",
                      "data-cy": "comment",
                      name: "comment"
                    },
                    model: {
                      value: _vm.comment,
                      callback: function($$v) {
                        _vm.comment = $$v
                      },
                      expression: "comment"
                    }
                  }),
                  _vm.errors.first("comment-management.comment")
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to"
                        },
                        [
                          _c("span", { staticClass: "span-text-validation" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first("comment-management.comment")
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.enableAttachButton
            ? _c(
                "div",
                { staticClass: "my-5 text-right" },
                [
                  _c("UploadMultipleFiles", {
                    attrs: {
                      permission: "*",
                      text: "Agregar",
                      "upload-to": _vm.urlFile,
                      maxSizeInMb: 100,
                      "type-button": "small",
                      "button-class": "",
                      "container-class": "text-right"
                    },
                    on: {
                      input: function($event) {
                        return _vm.addAdditionalFile($event)
                      }
                    },
                    model: {
                      value: _vm.file,
                      callback: function($$v) {
                        _vm.file = $$v
                      },
                      expression: "file"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "row" },
            [
              !_vm.commentFiles.length && _vm.action === "attach"
                ? _c("div", { staticClass: "col-9" }, [
                    _c("b", [
                      _vm._v(
                        "No hay documentos adjuntados. Seleccione al menos uno."
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._l(_vm.commentFiles, function(file) {
                return _c("div", { key: file.id, staticClass: "col-2" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _c("vs-icon", {
                        attrs: {
                          icon: "description",
                          size: "30px",
                          color: "primary"
                        }
                      }),
                      _c(
                        "b",
                        { staticClass: "text-truncate w-100 text-center" },
                        [_vm._v(" " + _vm._s(file.name) + " ")]
                      ),
                      _c("vs-button", {
                        attrs: { color: "danger", type: "flat", icon: "clear" },
                        on: {
                          click: function($event) {
                            return _vm.removeAdditionalFile(file.id)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              })
            ],
            2
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }